import { getApi } from "../apiCall";

// Cumulative (discom-perspective) reconciliation analytics.
// All endpoints require discom_id; state_id defaults to 6.
const BASE_URL = `${process.env.REACT_APP_API_URL}/banking/insights/banking_otc/cumulative`;

const buildQuery = (params) => {
  const query = Object.entries(params)
    .filter(
      ([, value]) => value !== null && value !== undefined && value !== "",
    )
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
  return query ? `?${query}` : "";
};

// GET /banking_otc/cumulative/overview
export const getReconOverview = (discomId, stateId = 6) => {
  const url = `${BASE_URL}/overview${buildQuery({
    discom_id: discomId,
    state_id: stateId,
  })}`;
  return getApi(url);
};

// GET /banking_otc/cumulative/supply (supports group_by: day | week | month)
export const getReconSupply = (discomId, groupBy = null, stateId = 6) => {
  const url = `${BASE_URL}/supply${buildQuery({
    discom_id: discomId,
    group_by: groupBy,
    state_id: stateId,
  })}`;
  return getApi(url);
};

// GET /banking_otc/cumulative/return (supports group_by: day | week | month)
export const getReconReturn = (discomId, groupBy = null, stateId = 6) => {
  const url = `${BASE_URL}/return${buildQuery({
    discom_id: discomId,
    group_by: groupBy,
    state_id: stateId,
  })}`;
  return getApi(url);
};

// GET /banking_otc/cumulative/supply-sources
export const getReconSupplySources = (discomId, stateId = 6) => {
  const url = `${BASE_URL}/supply-sources${buildQuery({
    discom_id: discomId,
    state_id: stateId,
  })}`;
  return getApi(url);
};

// GET /banking_otc/cumulative/supply-destinations
export const getReconSupplyDestinations = (discomId, stateId = 6) => {
  const url = `${BASE_URL}/supply-destinations${buildQuery({
    discom_id: discomId,
    state_id: stateId,
  })}`;
  return getApi(url);
};

// GET /banking_otc/cumulative/summary/export (no party_id/state_id)
export const getReconSummaryExport = (fmt = "xlsx") => {
  const url = `${BASE_URL}/summary/export${buildQuery({ fmt })}`;
  return getApi(url, {}, false, "blob");
};
